import PlatonPlugin from "@Platon/core/plugins/PlatonPlugin"
import { PLATON_ENABLE_SENTRY, PLATON_SENTRY_DNS, PLATON_SENTRY_URL } from "@Platon/const"

export default class PlatonSentryPlugin extends PlatonPlugin {
	load(core) {
		super.load(core)

		const isSentry = PLATON_ENABLE_SENTRY || process.env.VUE_APP_ENABLE_SENTRY

		if (isSentry) {
			this.loadSentry()
		}
	}

	loadSentry() {
		if (process.env.NODE_ENV == "production") {
			const { Integrations } = require("@sentry/tracing")
			const Sentry = require("@sentry/vue")

			Sentry.init({
				url: PLATON_SENTRY_URL || process.env.SENTRY_URL || "https://sentry.platon.uz",
				dsn: PLATON_SENTRY_DNS || process.env.VUE_APP_SENTRY_DNS,
				release: require("../../../package.json").version,
				environment: process.env.NODE_ENV,

				integrations: [new Integrations.BrowserTracing()],
				Vue: window.PlatonVue,
				tracesSampleRate: 0.2
			})
		}
	}
}
